(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-qty-stepper]').forEach(function (stepper) {
      var input = stepper.querySelector('[data-qty-input]');
      if (!input) return;
      var form = input.closest('form');

      stepper.addEventListener('click', function (event) {
        var btn = event.target.closest('[data-qty-action]');
        if (!btn) return;
        var current = parseInt(input.value, 10);
        if (isNaN(current)) current = 0;
        var next = btn.dataset.qtyAction === 'plus' ? current + 1 : current - 1;
        if (next < 0) next = 0;
        input.value = next;
        if (form) form.submit();
      });

      input.addEventListener('change', function () {
        if (form) form.submit();
      });
    });

    var promoForm = document.querySelector('[data-promo-form]');
    if (promoForm) {
      promoForm.addEventListener('submit', function (event) {
        event.preventDefault();
        var input = promoForm.querySelector('[data-promo-input]');
        var code = input ? input.value.trim() : '';
        if (!code) return;
        window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart';
      });
    }

    document.querySelectorAll('[data-cart-carousel]').forEach(function (car) {
      var track = car.querySelector('[data-cart-track]');
      if (!track) return;
      var prev = car.querySelector('[data-cart-prev]');
      var next = car.querySelector('[data-cart-next]');
      function update() {
        var overflow = track.scrollWidth > track.clientWidth + 4;
        var atStart = track.scrollLeft <= 4;
        var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
        if (prev) prev.hidden = !overflow || atStart;
        if (next) next.hidden = !overflow || atEnd;
      }
      function page() { return Math.max(track.clientWidth * 0.9, 180); }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -page(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: page(), behavior: 'smooth' }); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCarousel(car) {
      var track = car.querySelector('[data-fp-track]');
      if (!track || car.dataset.fpReady === '1') return;
      car.dataset.fpReady = '1';
      var prev = car.querySelector('[data-fp-prev]');
      var next = car.querySelector('[data-fp-next]');
      function update() {
        var overflow = track.scrollWidth > track.clientWidth + 4;
        var atStart = track.scrollLeft <= 4;
        var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
        if (prev) prev.hidden = !overflow || atStart;
        if (next) next.hidden = !overflow || atEnd;
      }
      function pageWidth() {
        return Math.max(track.clientWidth * 0.9, 200);
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -pageWidth(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: pageWidth(), behavior: 'smooth' }); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    }
    function initAll() {
      var cars = document.querySelectorAll('[data-fp-carousel]');
      for (var i = 0; i < cars.length; i++) initCarousel(cars[i]);
    }
    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.querySelectorAll('.site-header__drawer').forEach((drawer) => {
    const summary = drawer.querySelector('summary');
    if (!summary) return;
    drawer.addEventListener('toggle', () => {
      const label = drawer.open ? summary.dataset.labelClose : summary.dataset.labelOpen;
      if (label) summary.setAttribute('aria-label', label);
      document.body.style.overflow = drawer.open ? 'hidden' : '';
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["legal-page"] && !Shopify.designMode) return;
  try {
    
  /* Auto-generate TOC from h2 in the content area */
  (function () {
    var content = document.getElementById('legal-content');
    var toc = document.getElementById('legal-toc');
    if (!content || !toc) return;
    var headings = content.querySelectorAll('h2');
    if (!headings.length) {
      var aside = toc.closest('.legal-page__toc');
      if (aside) aside.style.display = 'none';
      return;
    }
    headings.forEach(function (h, idx) {
      var slug = h.id || ('section-' + (idx + 1));
      h.id = slug;
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + slug;
      a.textContent = h.textContent.trim();
      li.appendChild(a);
      toc.appendChild(li);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tech"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('.product-tech');
    sections.forEach((section) => {
      const tabs = section.querySelectorAll('[role="tab"]');
      const panels = section.querySelectorAll('[role="tabpanel"]');

      const activate = (idx) => {
        tabs.forEach((tab, i) => {
          const active = i === idx;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.setAttribute('tabindex', active ? '0' : '-1');
        });
        panels.forEach((panel, i) => {
          const active = i === idx;
          panel.classList.toggle('is-active', active);
          if (active) panel.removeAttribute('hidden');
          else panel.setAttribute('hidden', '');
        });
      };

      tabs.forEach((tab, idx) => {
        tab.addEventListener('click', () => activate(idx));
        tab.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
            e.preventDefault();
            const dir = e.key === 'ArrowRight' ? 1 : -1;
            const next = (idx + dir + tabs.length) % tabs.length;
            activate(next);
            tabs[next].focus();
          } else if (e.key === 'Home') {
            e.preventDefault();
            activate(0);
            tabs[0].focus();
          } else if (e.key === 'End') {
            e.preventDefault();
            const last = tabs.length - 1;
            activate(last);
            tabs[last].focus();
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('[data-section-id]');
    sections.forEach((section) => {
      if (!section.classList.contains('product-main')) return;
      const variantsData = section.querySelector('[data-product-variants]');
      if (!variantsData) return;

      let variants = [];
      try { variants = JSON.parse(variantsData.textContent); } catch (e) { return; }

      const main = section.querySelector('[data-gallery-main]');
      const thumbs = section.querySelectorAll('[data-thumb]');
      const variantInput = section.querySelector('[data-variant-id]');
      const priceWrapper = section.querySelector('[data-price-wrapper]');
      const currentPrice = section.querySelector('[data-current-price]');
      const atcPriceEl = section.querySelector('[data-atc-price]');
      const comparePrice = section.querySelector('[data-compare-price]');
      const stockEl = section.querySelector('[data-stock]');
      const atcButton = section.querySelector('[data-atc-button]');
      const atcLabel = section.querySelector('[data-atc-label]');
      const qtyInput = section.querySelector('[data-qty-input]');
      const qtyDec = section.querySelector('[data-qty-decrease]');
      const qtyInc = section.querySelector('[data-qty-increase]');
      const productForm = section.querySelector('.product-form');
      const addonCheck = section.querySelector('[data-addon-check]');
      const addonSize = section.querySelector('[data-addon-size]');
      const addonSizeWrap = section.querySelector('[data-addon-size-wrap]');
      const addonCents = () => {
        if (!addonCheck || !addonCheck.checked) return 0;
        if (addonSize && addonSize.value) {
          const opt = addonSize.selectedOptions[0];
          if (opt && opt.dataset.price) return parseInt(opt.dataset.price, 10) || 0;
        }
        return parseInt(addonCheck.dataset.addonPrice, 10) || 0;
      };

      const accessoryItems = Array.from(section.querySelectorAll('[data-accessory-item]'));
      const accessoryCents = () => {
        let sum = 0;
        accessoryItems.forEach((item) => {
          const check = item.querySelector('[data-accessory-check]');
          if (check && check.checked) {
            const price = parseInt(check.dataset.price, 10) || 0;
            const qtyEl = item.querySelector('[data-accessory-qty]');
            const q = qtyEl ? Math.max(1, parseInt(qtyEl.value, 10) || 1) : 1;
            sum += price * q;
          }
        });
        return sum;
      };

      const formatMoney = (cents) => {
        const value = (cents / 100).toFixed(2).replace('.', ',');
        return `${value} €`;
      };

      const getSelectedOptions = () => {
        const optionInputs = section.querySelectorAll('[data-product-options] [data-option-index]:checked');
        const opts = [];
        optionInputs.forEach((input) => {
          opts[parseInt(input.dataset.optionIndex, 10)] = input.value;
        });
        return opts;
      };

      const findVariant = (opts) => {
        return variants.find((v) => {
          const variantOpts = [v.option1, v.option2, v.option3].filter((o) => o !== null);
          if (opts.length !== variantOpts.length) return false;
          return opts.every((o, i) => o === variantOpts[i]);
        });
      };

      const variantExists = (test) => variants.some((v) => {
        const vo = [v.option1, v.option2, v.option3];
        return test.every((o, i) => o == null || o === vo[i]);
      });

      // Grise les valeurs de TAILLE sans variante pour la couleur/manche choisie (matrice à trous).
      const sizeFieldset = section.querySelector('.product-option--size');
      const updateOptionAvailability = () => {
        if (!sizeFieldset) return;
        const sizeIdx = parseInt(sizeFieldset.dataset.optionIndex, 10);
        const sel = getSelectedOptions();
        sizeFieldset.querySelectorAll('.product-option__input').forEach((input) => {
          const test = sel.slice();
          test[sizeIdx] = input.value;
          input.disabled = !variantExists(test);
        });
      };

      const updateUI = (variant) => {
        if (!variant) {
          if (atcButton) {
            atcButton.disabled = true;
            atcLabel.textContent = 'Indisponible';
          }
          return;
        }
        variantInput.value = variant.id;
        // BSS B2B: sync the variant id on the price elements BEFORE rewriting the text, so the app's
        // observer re-renders the B2B/Pro price for the newly selected variant. No-op if BSS is absent.
        [currentPrice, atcPriceEl].forEach((el) => {
          if (el && el.hasAttribute('bss-b2b-variant-id')) {
            el.setAttribute('bss-b2b-variant-id', variant.id);
          }
        });
        if (currentPrice) currentPrice.textContent = formatMoney(variant.price);
        if (atcPriceEl) atcPriceEl.textContent = formatMoney(variant.price + addonCents() + accessoryCents());
        if (comparePrice) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            comparePrice.textContent = formatMoney(variant.compare_at_price);
            comparePrice.hidden = false;
          } else {
            comparePrice.hidden = true;
          }
        }
        if (stockEl) {
          stockEl.classList.toggle('is-available', variant.available);
          stockEl.classList.toggle('is-unavailable', !variant.available);
        }
        if (atcButton) {
          atcButton.disabled = !variant.available;
        }

        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      };

      const updateSelectedValueLabels = () => {
        section.querySelectorAll('[data-option-index][data-option-index]').forEach(() => {});
        section.querySelectorAll('.product-option').forEach((fieldset) => {
          const idx = fieldset.dataset.optionIndex;
          const checked = fieldset.querySelector(`[data-option-index="${idx}"]:checked`);
          const labelEl = fieldset.querySelector('[data-selected-value]');
          if (labelEl && checked) labelEl.textContent = checked.value;
        });
      };

      section.querySelectorAll('[data-option-index]').forEach((input) => {
        input.addEventListener('change', () => {
          updateSelectedValueLabels();
          updateOptionAvailability();
          let variant = findVariant(getSelectedOptions());
          // Si la combinaison choisie n'existe pas (taille indispo pour cette couleur/manche),
          // bascule sur la première taille disponible pour rester achetable.
          if (!variant && sizeFieldset) {
            const firstOk = sizeFieldset.querySelector('.product-option__input:not(:disabled)');
            if (firstOk && !firstOk.checked) {
              firstOk.checked = true;
              updateSelectedValueLabels();
              variant = findVariant(getSelectedOptions());
            }
          }
          updateUI(variant);
        });
      });

      updateOptionAvailability();

      if (addonCheck) {
        addonCheck.addEventListener('change', () => {
          if (addonSizeWrap) addonSizeWrap.hidden = !addonCheck.checked;
          updateUI(findVariant(getSelectedOptions()));
        });
      }
      if (addonSize) {
        addonSize.addEventListener('change', () => {
          addonSize.classList.remove('is-invalid');
          updateUI(findVariant(getSelectedOptions()));
        });
      }

      accessoryItems.forEach((item) => {
        const check = item.querySelector('[data-accessory-check]');
        const qtyEl = item.querySelector('[data-accessory-qty]');
        if (check) {
          check.addEventListener('change', () => {
            if (qtyEl) qtyEl.disabled = !check.checked;
            updateUI(findVariant(getSelectedOptions()));
          });
        }
        if (qtyEl) {
          qtyEl.addEventListener('input', () => updateUI(findVariant(getSelectedOptions())));
        }
      });

      if (productForm && (addonCheck || accessoryItems.length > 0)) {
        productForm.addEventListener('submit', (e) => {
          e.preventDefault();
          const qty = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
          const items = [{ id: parseInt(variantInput.value, 10), quantity: qty }];
          if (addonCheck && addonCheck.checked) {
            let addonId = parseInt(addonCheck.dataset.addonVariantId, 10);
            if (addonSize) {
              if (!addonSize.value) {
                if (addonSizeWrap) addonSizeWrap.hidden = false;
                addonSize.classList.add('is-invalid');
                addonSize.focus();
                return;
              }
              addonId = parseInt(addonSize.value, 10);
            }
            items.push({ id: addonId, quantity: qty });
          }
          accessoryItems.forEach((item) => {
            const check = item.querySelector('[data-accessory-check]');
            if (check && check.checked) {
              const id = parseInt(check.dataset.variantId, 10);
              const qtyEl = item.querySelector('[data-accessory-qty]');
              const q = qtyEl ? Math.max(1, parseInt(qtyEl.value, 10) || 1) : 1;
              if (id) items.push({ id: id, quantity: q });
            }
          });
          if (atcButton) { atcButton.disabled = true; atcButton.setAttribute('aria-busy', 'true'); }
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items }),
          })
            .then((r) => r.json())
            .then(() => { window.location.href = '/cart'; })
            .catch(() => {
              if (atcButton) { atcButton.disabled = false; atcButton.removeAttribute('aria-busy'); }
            });
        });
      }

      const sizeGuideLink = section.querySelector('[data-size-guide-link]');
      if (sizeGuideLink && sizeGuideLink.getAttribute('href').charAt(0) === '#') {
        sizeGuideLink.addEventListener('click', (e) => {
          const target = document.querySelector(sizeGuideLink.getAttribute('href'));
          if (target) {
            e.preventDefault();
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      }

      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          const src = thumb.dataset.mediaSrc;
          const img = main && main.querySelector('img');
          if (img && src) {
            img.src = src;
            img.srcset = '';
          }
          thumbs.forEach((t) => t.classList.remove('is-active'));
          thumb.classList.add('is-active');
        });
      });

      if (qtyDec && qtyInput) {
        qtyDec.addEventListener('click', () => {
          const v = Math.max(1, parseInt(qtyInput.value, 10) - 1);
          qtyInput.value = v;
        });
      }
      if (qtyInc && qtyInput) {
        qtyInc.addEventListener('click', () => {
          const v = parseInt(qtyInput.value, 10) + 1;
          qtyInput.value = v;
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
